import { AppUnit } from './app-unit';
import { PlatformType } from './platform-type';

export class UserActivity {
    appUnit: AppUnit;
    route: string;
    platformType: PlatformType;
}
